import { Injectable } from '@angular/core';
import { MatDialogRef, MatDialog } from '@angular/material/dialog';
import { ConfirmDialogOptions } from './confirm-dialog-options';
import { ConfirmDialogComponent } from './confirm-dialog.component';

@Injectable({
  providedIn: 'root'
})
export class ConfirmDialogService
{

  constructor(public dialog: MatDialog) { }

  public openDialog(confirmOptions: ConfirmDialogOptions): MatDialogRef<ConfirmDialogComponent>
  {
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      maxWidth: "400px",
      data: confirmOptions,
      disableClose: true
    });

    return dialogRef;
  }
}
